export const CapabilitiesStateKeys = Object.freeze({
  IS_MOBILE: 'IS_MOBILE',
  IS_TABLET: 'IS_TABLET',
});

export const CapabilitiesActions = Object.freeze({
  SET_CAPABILITIES: 'SET_CAPABILITIES',
});
